// Function to get URL parameters with error handling
function getURLParameter(name) {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  } catch (error) {
    console.warn("Error parsing URL parameters:", error);
    return null;
  }
}

// Get UTM source if exists
const utmSource = getURLParameter("utm_source") || "direct";

// Function to set up Privy tracking
function setupPrivyTracking() {
  // Handle original Privy buttons
  const originalPrivyBtns = document.querySelectorAll("#privy-submit-btn");
  // Handle new Privy popup buttons
  const popupPrivyBtns = document.querySelectorAll(
    '.privy-widget-button[data-testid="base-button-element"]'
  );

  // Combine both button sets into an array
  const allPrivyBtns = [...originalPrivyBtns, ...popupPrivyBtns];

  if (allPrivyBtns.length > 0) {
    allPrivyBtns.forEach(function (button) {
      // Check if event listener is already attached
      if (!button.dataset.trackerAttached) {
        button.dataset.trackerAttached = "true";
        button.addEventListener("click", function (event) {
          if (typeof gtag === "function") {
            // Determine which type of Privy form was used
            const formType =
              button.id === "privy-submit-btn"
                ? "privy"
                : "privy_discount_popup";

            gtag("event", "subscribe_submit", {
              subscription_method: "privy",
              source: utmSource,
              form_type: formType,
            });
          } else {
            console.warn("Google Analytics not loaded");
          }
        });
      }
    });
  }
}

// Function to set up footer form tracking
function setupFooterTracking() {
  const footerForm = document.querySelector("#footer-newsletter");
  if (footerForm && !footerForm.dataset.trackerAttached) {
    footerForm.dataset.trackerAttached = "true";
    footerForm.addEventListener("submit", function (event) {
      event.preventDefault();

      let formSubmitted = false;
      const originalForm = this;
      const timeoutId = setTimeout(() => {
        submitForm();
      }, 1000);

      function submitForm() {
        if (!formSubmitted) {
          formSubmitted = true;
          clearTimeout(timeoutId);
          originalForm.submit();
        }
      }

      if (typeof gtag === "function") {
        gtag("event", "subscribe_submit", {
          subscription_method: "footer_form",
          source: utmSource,
          event_callback: submitForm,
        });
      } else {
        console.warn("Google Analytics not loaded");
        submitForm();
      }
    });
  }
}

// Klaviyo event handler
const klaviyoHandler = function (e) {
  if (e.detail.type === "submit") {
    if (typeof gtag === "function") {
      gtag("event", "subscribe_submit", {
        subscription_method: "klaviyo",
        source: utmSource,
      });
    } else {
      console.warn("Google Analytics not loaded");
    }
  }
};

// Add Klaviyo event listener
window.addEventListener("klaviyoForms", klaviyoHandler);

// Function to check and setup all tracking
function checkAndSetupTracking() {
  setupPrivyTracking();
  setupFooterTracking();
}

// Initial check
checkAndSetupTracking();

// Poll for elements every 1 second for 30 seconds
let attempts = 0;
const maxAttempts = 30;
const interval = setInterval(() => {
  attempts++;
  checkAndSetupTracking();

  if (attempts >= maxAttempts) {
    clearInterval(interval);
    console.log("Stopped checking for form elements after 30 seconds");
  }
}, 1000);

// Cleanup function for SPA support
window.addEventListener("unload", function () {
  clearInterval(interval);
  window.removeEventListener("klaviyoForms", klaviyoHandler);
});
